import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./PanelControls.scss";

const PanelControls = ({ backOptions, nextOptions }) => (
	<div
		id="signup-panel-controls"
		className="row"
	>
		<If condition={backOptions}>
			<div className={nextOptions ? "col-xs-6" : "col-xs-12"}>
				<button
					id="back-button"
					type="button"
					className="btn btn-link"
					onClick={backOptions.onClick}
				>
					<If condition={backOptions.icon}>
						<i className={`rkf ${backOptions.icon}`} />
					</If>
					{backOptions.label}
				</button>
			</div>
		</If>
		<If condition={nextOptions}>
			<div className={classNames("text-right", backOptions ? "col-xs-6" : "col-xs-12")}>
				<button
					id="next-button"
					type="button"
					className="btn btn-primary"
					onClick={nextOptions.onClick}
				>
					<If condition={nextOptions.icon}>
						<i className={`rkf ${nextOptions.icon}`} />
					</If>
					{nextOptions.label}
				</button>
			</div>
		</If>
	</div>
);

PanelControls.propTypes = {
	backOptions: PropTypes.object,
	nextOptions: PropTypes.object,
};

PanelControls.defaultProps = {
	backOptions: null,
	nextOptions: null,
};

export default PanelControls;
